<template>
  <div class="data-row">
    <div class="col" v-for="(col, idx) in data" :key="idx">
      <div class="top">
        <div class="label">{{ col.label }}</div>
        <div class="selector">
          <Select style="width: 50px" @on-change="onItemChange($event, idx)" placeholder="">
            <Option v-for="item in displayItems" :value="item.value" :key="item.value">{{ item.label }} </Option>
          </Select>
        </div>
      </div>
      <div class="mid">
        <span class="value" :class="loading && 'loading'">
          <span v-if="col.format">
            {{ col.format(col.thisPeriodValue || 0) }}
          </span>
          <span v-else>
            {{ col.thisPeriodValue || 0 }}
          </span>
          <span class="unit">{{ col.unit }}</span>
        </span>
      </div>
      <div class="bottom">
        <span>环比</span>

        <span v-if="col.rate === '-'">&ensp;-</span>
        <template v-else>
          <span class="positive" v-if="col.rate > 0">
            <Icon v-if="loading" class="loading-icon spin-animate" type="ios-loading" />
            <template v-else>
              <Icon size="20" color="#09CD8E" type="md-arrow-dropup" />
              <span>{{ col.rate | toPercent }}</span>
            </template>
          </span>
          <span class="nagetive" v-else>
            <Icon v-if="loading" class="loading-icon spin-animate" type="ios-loading" />
            <template v-else>
              <Icon size="20" color="#F1403C" type="md-arrow-dropdown" />
              <span>{{ col.rate | toPercent }}</span>
            </template>
          </span>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { displayItems } from '../../consts/index.js'
import { getLocal, setLocal } from '@/common/js/api'
export default {
  props: {
    // 当前展示数据项的value数组
    value: {
      type: Array
    },
    // 展示数据
    data: {
      type: Array
    },
    loading: {
      type: Boolean
    }
  },
  computed: {
    displayItems() {
      return displayItems
    }
  },
  methods: {
    onItemChange(v, idx) {
      const value = this.value
      value.splice(idx, 1, v)
      this.$emit('input', value)
      setLocal('summary-cols', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.data-row {
  display: flex;
  overflow: hidden;
  .col {
    flex: 1;
    flex-basis: 12.5%;
    background: #f3fbff;
    margin-right: 16px;
    margin-bottom: 16px;
    padding: 16px;
    border-radius: 4px;
    &:last-child {
      margin-right: 0;
    }
    .top {
      display: flex;
      .label {
        font-size: 12px;
        font-weight: 600;
        color: #000;
        white-space: nowrap;
      }
      ::v-deep .selector {
        .ivu-select {
          .ivu-select-selection {
            background: transparent;
            border: none;
            box-shadow: none;
            height: 20px;
            > div {
              span {
                visibility: hidden;
              }
            }
          }
          .ivu-icon {
            right: 30px;
            top: 8px;
          }
        }
      }
    }
    .mid {
      white-space: nowrap;
      font-size: 20px;
      color: #252525; // #000 85%
      height: 34px;
      line-height: 34px;
      letter-spacing: -1px;
      .value {
        &.loading {
          filter: blur(2px);
          animation: breath 3s linear infinite;
        }
      }
      .unit {
        font-size: 12px;
        color: #434343;
      }
    }
    .bottom {
      font-size: 12px;
      color: #434343;
      height: 20px;
      line-height: 20px;

      .positive {
        color: #09cd8e;
      }
      .nagetive {
        color: #f1403c;
      }
    }
  }
}
@keyframes breath {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.loading-icon {
  margin-left: 5px;
}
.spin-animate {
  animation: spin 1s linear infinite;
}
</style>
